import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { goToPage } from '../DisconnectServiceSlice'
import DisconnectCellularPage from './DisconnectCellularPage/DisconnectCellularPage'
import DisconnectInternetPage from './DisconnectInternetPage/DisconnectInternetPage'
import DisconnectTVPage from './DisconnectTVPage/DisconnectTVPage'
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';

function DisconnectPage(props) {

    const priceToPass = props.cost;
    const type = props.serviceToDisconnect.serviceType;
    const canDisconnect = props.serviceToDisconnect.canDisconnectOnline;
    const upgradedPackage = props.commercialPic;
    const upgradedKosherPackage = props.kosherCommercialPic;
    const pdf = props.commercialPdf;
    const code = props.programCode;
    const showCellularPackage = props.displayDiscountPackage;
    const kosherShowPackage = props.displayKosherDiscountPackage;
    const kosherCode = props.kosherProgramCode;

    useEffect(() => {
      if (typeof window.scrollTo === "function") { 
        window.scrollTo(0, 0);
      } 
    }, [])

    useEffect(() => {
      switch (type) {
        case 'TV': gaEvent(gaParams.DISCONNECT_ENTER_DISCONNECT_PAGE.category, gaParams.DISCONNECT_ENTER_DISCONNECT_PAGE.eventType, type)
          break;
        case 'Internet': gaEvent(gaParams.DISCONNECT_ENTER_DISCONNECT_PAGE.category, gaParams.DISCONNECT_ENTER_DISCONNECT_PAGE.eventType, type)
          break;
        case 'Cellular': gaEvent(gaParams.DISCONNECT_ENTER_DISCONNECT_CELLULAR_PAGE.category, gaParams.DISCONNECT_ENTER_DISCONNECT_CELLULAR_PAGE.eventType, gaParams.DISCONNECT_ENTER_DISCONNECT_CELLULAR_PAGE.eventParams)
          break;
        default: gaEvent(gaParams.DISCONNECT_ENTER_DISCONNECT_PAGE.category, gaParams.DISCONNECT_ENTER_DISCONNECT_PAGE.eventType, type)
          break;
      }
    },[])
    
    function renderToStep() {
      switch (type) {
        case 'TV': return (
          (canDisconnect ? <DisconnectTVPage priceToPass={priceToPass}/> : null)
        )
        case 'Internet': return (
          (canDisconnect ? <DisconnectInternetPage priceToPass={priceToPass}/> : null)
        )
        case 'Cellular': return (
          (canDisconnect ? <DisconnectCellularPage upgradedPackage={upgradedPackage} pdf={pdf} upgradedKosherPackage={upgradedKosherPackage} code={code} showCellularPackage={showCellularPackage} kosherShowPackage={kosherShowPackage} kosherCode={kosherCode}/> : null)
        )
        default: return (canDisconnect ? <DisconnectInternetPage priceToPass={priceToPass}/> : null)
      }
    }

    return (
      <div>
        {renderToStep()}
      </div>
    )
}

const mapStateToProps = (state) => ({
  stepParams: state.disconnectServicesBlock.stepParams,
  serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect
});
  
const mapDispatchToProps = {
  goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectPage);
